import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
//import heroPortraitImage from '../assets/images/stellaTerm.png'
import noiseImage from '../assets/images/thenoise.png'
import clarityImage from '../assets/images/clairty.png'
import heroBackgroundImage from '../assets/images/bg.png'
import heroPortraitVideo from '../assets/images/stellaTerm.mp4'

const DOCS_URL = "https://docs.stellarisapp.com";
const X_URL = 'https://x.com/stellarisapp/'


type EngineCard = {
    icon: string;
    title: string;
    description: string;
    label: string;
};

const engineCards: EngineCard[] = [
    {
        icon: '⌁',
        title: 'Organic Volume',
        description: 'High-frequency throughput engineered for stronger saturation and controlled market presence.',
        label: 'Precision Logic',
    },
    {
        icon: '◉',
        title: 'Liquidity Injection',
        description: 'Seamless depth provisioning across pools with tighter execution and cleaner capital routing.',
        label: 'Stabilized Flow',
    },
    {
        icon: '✦',
        title: 'Smart Extraction',
        description: 'Signal-aware yield harvesting shaped for faster reactions and more disciplined exits.',
        label: 'Disciplined Exit',
    },
];

const LandingPage: React.FC = () => {
    return (
        <div className="landing-page landing-page--sovereign" id="top">
            <header className="landing-page__header">
                <nav className="landing-page__nav">
                    <Link className="landing-page__brand" to="/">
                        <img src="/logo1.png" alt="Stellaris" className="landing-page__brand-logo" />
                        STELLARIS
                    </Link>

                    <div className="landing-page__nav-links">
                        <a href={DOCS_URL} target="_blank" rel="noopener noreferrer">Docs</a>
                        <Link to="/login">App</Link>
                    </div>

                    <div></div>
                </nav>
            </header>

            <main className="landing-page__main">
                <section className="landing-page__hero">
                    <div className="landing-page__hero-backdrop">
                        <img src={heroBackgroundImage} alt="" aria-hidden="true" referrerPolicy="no-referrer" />
                        
                    </div>

                    <div className="landing-page__container landing-page__hero-grid">
                        <div className="landing-page__hero-copy">
                            <div className="landing-page__hero-rule" aria-hidden="true" />
                            <p className="landing-page__eyebrow">Stellaris Relay Activated</p>
                            <h1 className="landing-page__hero-title">
                                The Market,
                                <span><br />Refined.</span>
                            </h1>
                            <p className="landing-page__hero-text">
                                Cut through the noise. Production-grade Solana execution infrastructure for synchronized multi-wallet coordination and MEV-protected liquidity management.
                            </p>

                            <div className="landing-page__hero-actions">
                                <Link className="landing-page__button landing-page__button--primary" to="/login">
                                    Ignite the Signal
                                </Link>
                                <a className="landing-page__button landing-page__button--secondary" href={DOCS_URL} target="_blank" rel="noopener noreferrer">
                                    View Manifest
                                </a>
                            </div>
                        </div>

                        <div className="landing-page__hero-visual">
                            <div className="landing-page__hero-frame">
                                <div className="landing-page__hero-frame-edge" aria-hidden="true" />
                                <video
                                    src={heroPortraitVideo}
                                    style={{ width: '100%', height: 'auto' }}
                                    autoPlay
                                    muted
                                    playsInline
                                    //loop
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing-page__compare">
                    <div className="landing-page__container landing-page__compare-grid">
                        <article className="landing-page__compare-card landing-page__compare-card--noise">
                            <div className="landing-page__compare-copy">
                                <h2>
                                    The <span>Noise</span>
                                </h2>
                                <p>Fragmented, low-fidelity tools. Stop wrestling with disjointed Telegram bots, generic DCA buttons, and uncoordinated wallets that leak value.</p>
                            </div>
                            <div className="landing-page__compare-visual landing-page__compare-visual--noise">
                                <img src={noiseImage} alt="Abstract digital distortion" referrerPolicy="no-referrer" />
                            </div>
                        </article>

                        <article className="landing-page__compare-card landing-page__compare-card--clarity">
                            <div className="landing-page__compare-copy">
                                <h2>
                                    The <span>Clarity</span>
                                </h2>
                                <p>Sharp, coordinated execution in real time. Seamlessly synchronize multi-wallet operations with MEV-protected routing and sub-second state management.</p>
                            </div>
                            <div className="landing-page__compare-visual landing-page__compare-visual--clarity">
                                <img src={clarityImage} alt="Clean futuristic intelligence dashboard" referrerPolicy="no-referrer" />
                            </div>
                        </article>
                    </div>
                </section>

                <section className="landing-page__engine">
                    <div className="landing-page__container">
                        <div className="landing-page__section-header landing-page__section-header--center">
                            <p className="landing-page__section-mark" />
                            <h2>The Core Engine</h2>
                        </div>

                        <div className="landing-page__engine-grid">
                            {engineCards.map((card) => (
                                <article key={card.title} className="landing-page__engine-card">
                                    <div className="landing-page__engine-icon">{card.icon}</div>
                                    <h3>{card.title}</h3>
                                    <p>{card.description}</p>
                                    <div className="landing-page__engine-chip">
                                        <span className="landing-page__engine-chip-dot" />
                                        {card.label}
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="landing-page__final-cta">
                    <div className="landing-page__container landing-page__final-cta-inner">
                        <h2>
                            Command The <span>Market.</span>
                        </h2>
                        <Link className="landing-page__button landing-page__button--outline" to="/login">
                            Ignite The Relay
                        </Link>
                    </div>
                </section>
            </main>

            <footer className="landing-page__footer">
                <div className="landing-page__container landing-page__footer-inner">
                    <div className="landing-page__footer-brand">STELLARIS</div>
                    <div className="landing-page__footer-links">
                        <a href={DOCS_URL} target="_blank" rel="noopener noreferrer">DOCS</a>
                        <a href={X_URL} target="_blank" rel="noopener noreferrer">X</a>
                    </div>
                    <div className="landing-page__footer-copy">© 2026 STELLARIS.</div>
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;
